import { defineMessages } from 'react-intl';

const upgradeYourScheduleMessages = defineMessages({
  featureName: {
    id: 'unlock.yourSchedule',
    defaultMessage: 'Your Schedule',
  },
  featureSummary: {
    id: 'unlock.yourSchedule.summary',
    defaultMessage: 'A summary of your upcoming appointments will show here when you upgrade',
  },
  featureUnlockAction: {
    id: 'unlock.yourSchedule.action',
    defaultMessage: 'Learn more',
  },
});

export default upgradeYourScheduleMessages;
